/**
 * http配置
 */
import axios from 'axios'
import Config from './config/config'
import store from './store'
// import router from './router'
// import Datetime from './util/datetime'
import { Toast } from 'vant'

// axios 配置
axios.defaults.timeout = 50000
axios.defaults.baseURL = Config.apiBaseUrl
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true

// http request 拦截器
axios.interceptors.request.use(
  config => {
    Toast.loading({ message: '加载中,请稍后' })
    if (store.state.xAuth.appId) {
      config.headers['X-APP-ID'] = store.state.xAuth.appId
      config.headers['X-USER-CODE'] = store.state.xAuth.userCode
    }
    return config
  },
  err => {
    Toast.clear()
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    Toast.clear()
    // console.log(response)
    return response
  },
  error => {
    Toast.clear()
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http.js